
import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
import { CheckCircle2, Phone, Mail } from 'lucide-react';

export default function ServicePage({ serviceKey }) {
  const { t } = useLanguage();
  const service = t.sections[serviceKey];

  if (!service) return null;

  return (
    <div className="bg-white">
      {/* Page Header */}
      <div className="relative bg-slate-950 py-16 md:py-24 lg:py-40 text-white border-b border-slate-800 overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0 z-0">
          <img 
            src={service.image} 
            alt="" 
            className="w-full h-full object-cover opacity-20 brightness-50"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/60 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950/80 via-transparent to-transparent" />
        </div>

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6 tracking-tight border-l-4 border-[#f59c01] pl-4 inline-block">
              {service.title}
            </h1>
            <p className="text-xl md:text-2xl text-slate-300 leading-relaxed">
              {service.description}
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <section className="py-12 md:py-16 lg:py-24">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row-reverse gap-16 items-start">
            <div className="lg:w-1/2">
              <h2 className="text-3xl font-bold text-slate-900 mb-8 border-l-4 border-[#f59c01] pl-4 inline-block">
                {t.ui.weOffer}
              </h2>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <CheckCircle2 className="h-6 w-6 text-[#f59c01] mr-3 flex-shrink-0" />
                    <span className="text-slate-700 font-medium">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:w-1/2">
              <div className="aspect-[21/9] lg:aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl border border-slate-100">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
